import { popoutMenuActionType } from '../typings';
import attachPopoutMenu from '../helpers/attach-popout-menu';

export default function languagesBox(actionType: popoutMenuActionType): void {
    attachPopoutMenu('.js-languages', '.js-languages__list', actionType);
}
